<template>
  <b-nav-item-dropdown right class="dd-right">
    <template slot="button-content">
      <v-gravatar :email="currentUserEmail" class="img-avatar" :alt="currentUserEmail"/>
    </template>
    <b-dropdown-item to="/admin/users" v-if="isAdminRole">
        <div class="dd-icon" v-html="svg.ddAdmin"></div><span class="dd-text">{{ $t('HEADER.USERS') }}</span>
    </b-dropdown-item>
    <b-dropdown-item @click="logOut" >
      <div class="dd-icon" v-html="svg.ddLogout"></div><span class="dd-text">{{ $t('HEADER.LOGOUT') }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>
<script>
  import { mapGetters } from 'vuex'
  import svg from '../../_svg.js'
  export default {
    name: 'header-dropdown-accnt',
    data () {
      return {
        svg: svg
      }
    },
    methods: {
      logOut: function () {
        this.$store.dispatch('logOut')
      }
    },
    computed: {
      ...mapGetters(['isAdmin', 'currentUserEmail']),
      isAdminRole () {
        return this.isAdmin
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/micp/micpHeaderAccount.vue